import { describeFields, FieldWidget } from '../common/fields';
import { LegacyExamSchema } from './schemas';

export const LEGACY_EXAM_FIELDS = describeFields(LegacyExamSchema, {
  subject: { widget: FieldWidget.Text },
  examId: {},
  creationDatetime: {},
  editDatetime: {},
  label: {},
  shortLabel: {},
  maxMark: {},
  topics: { widget: FieldWidget.Select },
  analytics: {},
  type: { options: [], displayField: 'typeLabel' },
  active: {},
});
